module.exports = "/_next/static/images/mitra-2-9a68d83bd9e37ed8c06e17eb2a136e9e.png";